import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 12 12.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12.3\" id=\"icon-phone\"><title>资源 1</title><g id=\"icon-phone_图层_2\" data-name=\"图层 2\"><g id=\"icon-phone_图层_1-2\" data-name=\"图层 1\"><path d=\"M6.3.7l.3,1a3.3,3.3,0,0,1,3.4.8,3.7,3.7,0,0,1,.8,3.3l1,.3a4.5,4.5,0,0,0-1-4.4A4.4,4.4,0,0,0,6.3.7Z\" /><path d=\"M6.1,1.6a.6.6,0,0,0,.8,0,.6.6,0,0,0,0-.8.6.6,0,0,0-.8,0A.6.6,0,0,0,6.1,1.6Z\" /><path d=\"M9,5.6a.6.6,0,0,0,.8,0,.5.5,0,0,0,0-.7c-.3-.3-.6-.3-.8,0a.5.5,0,0,0,0,.7Z\" /><path d=\"M6.9,3.6a.6.6,0,0,0,.8,0,.6.6,0,0,0,0-.8h0a.6.6,0,0,0-.8,0A.6.6,0,0,0,6.9,3.6Zm4,2.8a.6.6,0,1,0,.8-.8h0a.6.6,0,0,0-.8.8Z\" /><path d=\"M7.2,2.7l.2,1a1.5,1.5,0,0,1,1.1.4,1.3,1.3,0,0,1,.3,1l.9.3h.2a2.3,2.3,0,0,0-.7-2A2.4,2.4,0,0,0,7.2,2.7Z\" /><path d=\"M11.8,10.6v-.2a1.5,1.5,0,0,0,.1-.7A2.6,2.6,0,0,0,9.3,7.1a2.7,2.7,0,0,0-2.6,2A6.5,6.5,0,0,1,3.3,5.2a2.7,2.7,0,0,0,2-2.6h0A2.6,2.6,0,0,0,2.7,0L1.6.2A2.7,2.7,0,0,0,0,2.6V3a9.4,9.4,0,0,0,9.4,9.3h.2A2.6,2.6,0,0,0,11.8,10.6Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone.svg
// module id = 7pRf
// module chunks = 75